var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Array, answer, continueBtnText, dial, doneText, game, hasNarration, hasPrompt, i18n, labelValues, notches, prompt, submitUp, title, undefined) {
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
buf.push("<div class=\"content-fit block-v-xl content-fill\"><div class=\"row content-lg-fill content-sm-ver content-md-ver\"><div class=\"col-lg-6 col-sm-12 content-lg-ver block-v-lg block-v-lg\"><h1 class=\"text-lg-right text-center fade-in\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1></div><div class=\"col-lg-6 col-sm-12 content-lg-ver text-center block-v-lg\"><div class=\"dial scale-up\"><div class=\"dial-ring\"></div><div class=\"dial-knob dial-knob-input\"><div class=\"dial-knob-value dial-knob-input-value text-lg\">" + (null == (jade_interp = i18n("dial.touch-to-rotate")) ? "" : jade_interp) + "</div></div><div class=\"dial-knob dial-knob-answer\"><div class=\"dial-knob-value dial-knob-answer-value text-lg\">" + (null == (jade_interp = dial.prefix) ? "" : jade_interp) + (null == (jade_interp = answer.value) ? "" : jade_interp) + (null == (jade_interp = dial.suffix) ? "" : jade_interp) + "</div></div><div class=\"dial-notches\">");
// iterate new Array(notches)
;(function(){
  var $$obj = new Array(notches);
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var notch = $$obj[i];

buf.push("<div class=\"dial-notch\"></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var notch = $$obj[i];

buf.push("<div class=\"dial-notch\"></div>");
    }

  }
}).call(this);

buf.push("</div>");
if ( dial.labels)
{
buf.push("<div class=\"dial-labels\">");
// iterate labelValues
;(function(){
  var $$obj = labelValues;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var label = $$obj[$index];

buf.push("<div class=\"dial-label\"><div class=\"dial-label-text\">" + (null == (jade_interp = dial.prefix) ? "" : jade_interp) + (null == (jade_interp = dial.decimals ? label.toFixed(dial.decimals) : label) ? "" : jade_interp) + (null == (jade_interp = dial.suffix) ? "" : jade_interp) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var label = $$obj[$index];

buf.push("<div class=\"dial-label\"><div class=\"dial-label-text\">" + (null == (jade_interp = dial.prefix) ? "" : jade_interp) + (null == (jade_interp = dial.decimals ? label.toFixed(dial.decimals) : label) ? "" : jade_interp) + (null == (jade_interp = dial.suffix) ? "" : jade_interp) + "</div></div>");
    }

  }
}).call(this);

buf.push("</div>");
}
buf.push("</div></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"answer" in locals_for_with?locals_for_with.answer:typeof answer!=="undefined"?answer:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"dial" in locals_for_with?locals_for_with.dial:typeof dial!=="undefined"?dial:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"labelValues" in locals_for_with?locals_for_with.labelValues:typeof labelValues!=="undefined"?labelValues:undefined,"notches" in locals_for_with?locals_for_with.notches:typeof notches!=="undefined"?notches:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}